export default "__VITE_ASSET__DOsK0zeR__"